//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const manipulationURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NcCO05XSCVJbrZG6fAU1N95lLPVeifhy",
    frame: "Stacking moon in front of a tree in snapseed",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xehQbMLsm1jZZyO3BqzWwfuIz7C8iIIO",
    frame: "Stacking two images with snapseed",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1muPM7QJTO063oYPEi4c_yP0gi1jWjtSr",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1yLaho5DHI9PJu48g6ING_r_jVzNuz16S",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1GV8Wq-rzfqwoqJwnA1Fj3KzOtK3GansO",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1XzRneYQtr_tUwoALZgd6QG33Ygy0LW5X",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13MYpV541Xn1jULbVp74-lhGv89SPPAhI",
    frame: "Chhavi Sarda",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13__qlazM7dpPB9OvFiIKzjEy-MAjpMMZ",
    frame: "Ganesh idol, edited in snapseed",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13X2QtJQW0JaY7OqfGs4BAoE0MA7u_R5x",
    frame: "Ganesh idol, edited in snapseed",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13XrtNnPEzWS--w3krXc1OUdRSMngM-0m",
    frame: "Ganesh idol, edited in snapseed",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13QqfKll8SNgxRMTnQXsSYFw72nd-8Vky",
    frame: "Double Exposure in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13RcbhUbu9h0X4zSEKjMj5LQyXUfMY8RB",
    frame: "Double Exposure in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13UFEFzPqy48iZtNQbXKXvLiwQrd44CFm",
    frame: "Double Exposure in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13VF4OMAdAivSPiVEfbrooOYkOKah9myo",
    frame: "Double Exposure in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13fT3JvxOS1cKRMqeX3aQ3t2GAifgJD5O",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13hJEDJTGQCvp23pqOrxBcrOo3CKJAgC7",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13jBw2iCzNjW78HjkyE73SY66dXJg__jF",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=13dnGkfb2yrVwg7X_f6398WgnujxJr4Fn",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13ok_aM3NtopTb_GUUWVU3BQnG2FFY6q8",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13sYMU0a5qp-GpH8pjC-gMptofR6yqyTv",
    frame: "Edited in snapseed",
    location: "Mysore, Karnataka, India",
  },
];
